// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"9f67ae67","165":"effaed86","184":"50df8899","237":"38fe200d","896":"5efcf0ef"}[chunkId] + ".chunk.css";
};